/* eslint-disable global-require */
import Technology from '../../types/Technology';

const technologies: Technology[] = [
  {
    id: 1,
    image: require('../img/technologies/vue.png'),
    name: 'VueJS',
    description: 'skills.vuejs',
  },
  {
    id: 10,
    image: require('../img/technologies/react.webp'),
    name: 'ReactJS',
    description: 'skills.react',
  },
  {
    id: 20,
    image: require('../img/technologies/symfony.webp'),
    name: 'Symfony',
    description: 'skills.symfony',
  },
  {
    id: 30,
    image: require('../img/technologies/cypress.png'),
    name: 'Cypress',
    description: 'skills.cypress',
  },
  {
    id: 40,
    image: require('../img/technologies/storybook.webp'),
    name: 'Storybook',
    description: 'skills.storybook',
  },
  {
    id: 50,
    image: require('../img/technologies/html5.webp'),
    name: 'HTML5/CSS3',
    description: 'skills.html',
  },

  {
    id: 60,
    image: require('../img/technologies/gitlab-ci.png'),
    name: 'Gitlab CI',
    description: 'skills.gitlab-ci',
  },
  {
    id: 70,
    image: require('../img/technologies/mariadb.png'),
    name: 'MySQL/MariaDB',
  },
  {
    id: 80,
    image: require('../img/technologies/docker.png'),
    name: 'Docker',
    description: 'skills.docker',
  },
  {
    id: 90,
    image: require('../img/technologies/linux.png'),
    name: 'Linux',
    description: 'skills.linux',
  },
  {
    id: 100,
    image: require('../img/technologies/flutter.png'),
    name: 'Flutter',
    description: 'skills.flutter',
    addGrayFilter: true,
  },
  {
    id: 110,
    image: require('../img/technologies/redis.png'),
    name: 'Redis',
    description: 'skills.redis',
    addGrayFilter: true,
  },
  {
    id: 120,
    image: require('../img/technologies/svelte.png'),
    name: 'SvelteJS',
    description: 'skills.svelte',
    addGrayFilter: true,
  },
  {
    id: 130,
    image: require('../img/technologies/nodejs.webp'),
    name: 'NodeJS',
    description: 'skills.nodejs',
    addGrayFilter: true,
  },
];

export default technologies;
